// Received button
import {Button, styled} from "@mui/material";

export const ReceivedButtonLarge = styled(Button)(({theme}) => ({
    color: `${theme.barekam.sidebar.textDark} !important`,

    padding: '32px 24px',
    height: '87px',
    borderRadius: '0px',
    borderTopRightRadius: '12px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'inline-flex',

    '&:hover': {
        backgroundColor: theme.barekam.sidebar.tabButton.hover
    }
}));

export const ReceivedButtonSelectedLarge = styled(ReceivedButtonLarge)(({theme}) => ({
    background: theme.barekam.sidebar.tabButton.selected,
    color: `${theme.barekam.sidebar.textLight} !important`,
    fontWeight: 'bold',

    '&:hover': {
        backgroundColor: theme.barekam.sidebar.tabButton.hoverSelected
    }
}))

export const ReceivedButtonSmall = styled(ReceivedButtonLarge)(() => ({
    height: '3.25rem',
}))

export const ReceivedButtonSelectedSmall = styled(ReceivedButtonSelectedLarge)(() => ({
    height: '3.25rem',
}))

// Sent button
export const SentButtonLarge = styled(Button)(({theme}) => ({
    color: theme.barekam.sidebar.textDark,

    padding: '32px 24px 32px 24px',
    height: '74px',
    borderRadius: '0px',
    borderTopLeftRadius: '12px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'inline-flex',

    '&:hover': {
        backgroundColor: theme.barekam.sidebar.tabButton.hover
    }
}));

export const SentButtonSelectedLarge = styled(SentButtonLarge)(({theme}) => ({
    background: theme.barekam.sidebar.tabButton.selected,
    color: theme.barekam.sidebar.textLight,
    fontWeight: 'bold',

    '&:hover': {
        backgroundColor: theme.barekam.sidebar.tabButton.hoverSelected
    }
}))

export const SentButtonSmall = styled(SentButtonLarge)(() => ({
    width: '10.6875rem',
    height: '3.25rem',
}))

export const SentButtonSelectedSmall = styled(SentButtonSelectedLarge)(() => ({
    width: '10.6875rem',
    height: '3.25rem',
}))
